import { useSelector } from 'react-redux';

import { isDesktopAppDetected } from 'helpers/desktop-app/is-detected';
import { useFetchFeatures } from 'hooks/api/feature-control/use-fetch-features';
import { FeatureNames } from 'services/api/feature-control/interfaces';
import { getIsSubscriptionInTrial, getIsSubscriptionSubscribed } from 'store/entities/subscription/selectors';

export function useTextPromoEligibility(): boolean {
  const { data: features, isFetched: areFeaturesFetched, isSuccess: areFeaturesSuccessful } = useFetchFeatures();
  const isSubscribed = useSelector(getIsSubscriptionSubscribed);
  const isInTrial = useSelector(getIsSubscriptionInTrial);

  return (
    areFeaturesFetched &&
    areFeaturesSuccessful &&
    features[FeatureNames.TextPromo] &&
    isSubscribed &&
    !isInTrial &&
    !isDesktopAppDetected()
  );
}
